import { atom } from 'recoil';

import { CartStatus } from '~/types/cart';

const cartStatus = atom<CartStatus>({
  key: 'cartStatus',
  default: CartStatus.ACTIVE,
});

export default cartStatus;
